import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { CopilotContextService } from 'src/app/copilot/services/copilot-context.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig  } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PreviewTableComponent, IPreviewTableDelegate, ColumnInfo } from '../../../preview-table/preview-table.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { RowExtractorTransformRule, RowMissesOptionExtractor, RowMissesOptionExtractorUtil, SequenceOption, SequenceOptionUtil, ConsolidationLevel, ConsolidationLevelUtil, SmartSampleMode, SmartSampleModeUtil } from 'src/app/domainObjects/rowExtractorTransform';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { RowExtractorRuleViewModel } from './extractorRuleViewModel';
import { EndRuleTypeUtil, RowExtractorViewModel, StartRuleTypeUtil } from './extractorViewModel';
import { ExtractorStartRuleType, ExtractorEndRuleType } from 'src/app/messaging/engine';
import { TransformPipelineService } from 'src/app/services/transformPipeline/transform-pipeline.service';
import { BaseTransformerUIComponent } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
import { TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { TransformerTopHeaderComponent } from '../../transformer-top-header/transformer-top-header.component';
import { ColoredTextFindReplaceItem } from 'src/app/domainObjects/coloredTextItem';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { collectDistinctSourceFields } from 'src/app/views/shared/utils/source-field.util';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { OptionItemDataType } from 'src/app/model/optionItem';
import { DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { CopilotService } from 'src/app/copilot/services/copilot.service';
import { PreviewData } from 'src/app/domainObjects/previewData';

@Component({
    selector: 'app-extractor-transform-detail',
    templateUrl: './extractor-transform-detail.component.html',
    styleUrls: ['./extractor-transform-detail.component.css'],
    standalone: false
})
export class ExtractorTransformDetailComponent extends BaseTransformerUIComponent<RowExtractorViewModel>
  implements OnInit, IPreviewTableDelegate,ComponentCanDeactivate {
  RuleType = ExtractorStartRuleType;
 
  StartRuleTypes = [
    ExtractorStartRuleType.startsWith,
    ExtractorStartRuleType.startsAfter,
    ExtractorStartRuleType.beginning,
    ExtractorStartRuleType.justCopy,
    ExtractorStartRuleType.lengthBetween
  ];

  EndRuleTypes = [
    ExtractorEndRuleType.endsAtEnd,
    ExtractorEndRuleType.endsBefore,
    ExtractorEndRuleType.endsWith,
    ExtractorEndRuleType.ending,
    ExtractorEndRuleType.length,
    ExtractorEndRuleType.findPhrases
  ];

  StartRuleTypeUtil = StartRuleTypeUtil;
  EndRuleTypeUtil = EndRuleTypeUtil;
  EndRuleType = ExtractorEndRuleType;

  // Cached, not a live getter: this is read directly from six template bindings
  // (*ngIf/matTooltip/matTooltipDisabled). A getter re-evaluated on every change-detection
  // check is a confirmed NG0100 (ExpressionChangedAfterItHasBeenCheckedError) source here —
  // applyCopilotConfig reassigns this.viewModel.rules synchronously, in the same tick
  // Angular is already mid-cycle rendering the SSE-driven chat update, so the getter could
  // legitimately return a different boolean on the check pass vs. the verify pass. Updated
  // deterministically in _refreshHasFindPhrasesRules(), called everywhere viewModel.rules
  // is mutated (see _updateRuleTable()) and once at initial load (onRouteActivated()).
  hasFindPhrasesRules = false;

  private _refreshHasFindPhrasesRules(): void {
    this.hasFindPhrasesRules = this.viewModel?.rules?.some(r => r.endRuleType === ExtractorEndRuleType.findPhrases) ?? false;
  }

  // The Architect, 2026-09-30: a config mixing Find Phrases with other rule types
  // gets no multi-core benefit from the compiled engine at all today -- the whole
  // plan falls back to single-process the moment any one rule is Find Phrases
  // (row_extractor_compiled.py's hasFindPhrases flag is plan-wide, not per-rule),
  // even though the other rules would parallelize fine on their own. Checked at
  // Save (not on every live edit) -- Save is the moment that actually matters for
  // production performance, and warning on every keystroke while still editing
  // would just be noise. Purely advisory: whether splitting is actually safe
  // depends on rule ordering/dependencies only the Analyst can judge, so this
  // never blocks the save itself.
  //
  // Returns the warning text (or null) rather than opening its own snackbar --
  // MatSnackBar only ever shows one at a time, so a separate call here was
  // immediately replaced by the "Successfully saved" snackbar the moment the
  // save completed (as little as 1-2s later), cutting this one off before it
  // could be read. The caller appends this into that SAME snackbar instead.
  private _mixedFindPhrasesWarningIfAny(): string | null {
    const activeRules = (this.viewModel?.rules ?? []).filter(r => r.run !== false);
    const hasFindPhrases = activeRules.some(r => r.endRuleType === ExtractorEndRuleType.findPhrases);
    const hasNonFindPhrases = activeRules.some(r => r.endRuleType !== ExtractorEndRuleType.findPhrases);
    if (!hasFindPhrases || !hasNonFindPhrases) { return null; }
    return 'If the Find Phrases rules in this config have no dependency relationships with the other rules, ' +
      'you may be able to improve large scale data farm performance by moving the Find Phrases rules to another Row Extractor. ' +
      'Any Find Phrases rule(s) disables multi-threading which will reduce performance on all other rule types.';
  }

  // One paragraph per option, rendered via the "pre-line-tooltip" matTooltipClass
  // (styles.scss sets white-space: pre-line on that class) so the blank lines below
  // actually show as separate paragraphs rather than collapsing into one line.
  readonly variantsTooltip =
    'Find Phrases only. Maximum number of distinct output phrase variants to keep.\n\n' +
    '-1 = All. If Consolidation is Off: every distinct variant survives untouched, no merging at all. ' +
    'If Consolidation is at any other level: defers entirely to Consolidation to group variants into categories.\n\n' +
    '0 = Smart Variants. If Consolidation is Off: auto-detects a sensible variant count on its own — the ' +
    'only thing managing count in that case. If Consolidation is at any other level: behaves identically to ' +
    '-1 above (defers entirely to Consolidation) — running its own auto-estimate at the same time would fight ' +
    'Consolidation and make it very hard to tune.\n\n' +
    'N = cap output to the N most common variants regardless of Consolidation; rarer variants are merged into a survivor or become misses.';

  RowMissesOptionExtractorUtil = RowMissesOptionExtractorUtil;
  RowMissesOptionExtractor = RowMissesOptionExtractor;
  RowMissesOptionExtractors = [
    RowMissesOptionExtractor.keeptarget,
    RowMissesOptionExtractor.keepsource,
    RowMissesOptionExtractor.delete,
    RowMissesOptionExtractor.empty,
    RowMissesOptionExtractor.named
  ];

  SequenceOptionUtil = SequenceOptionUtil;
  SequenceOption = SequenceOption;
  SequenceOptions = [
    SequenceOption.base,
    SequenceOption.multiTarget,
    SequenceOption.recursive,
  ];

  ConsolidationLevelUtil = ConsolidationLevelUtil;
  ConsolidationLevel = ConsolidationLevel;
  // Display order (Architect-requested, 2026-09-08): most-aggressive to
  // least, ending with Off — the reverse of the enum's own numeric order.
  // Standard remains the default VALUE; this only changes dropdown order.
  ConsolidationLevels = [
    ConsolidationLevel.compact,
    ConsolidationLevel.high,
    ConsolidationLevel.standard,
    ConsolidationLevel.low,
    ConsolidationLevel.detailed,
    ConsolidationLevel.off,
  ];

  SmartSampleModeUtil = SmartSampleModeUtil;
  SmartSampleMode = SmartSampleMode;
  SmartSampleModes = [
    SmartSampleMode.per_field,
    SmartSampleMode.combined,
  ];
  
  dataSource: MatTableDataSource<RowExtractorRuleViewModel> | undefined;
  displayedColumns: string[] = [
    'actions',
    'index',
    'name',
    'sourceField',
    'targetField',
    'startRule',
    'startString',
    'startIndex',
    'endRule',
    'endString',
    'endIndex',
    'maxSearch',
    'minLength',
    'maxLength',
    'findReplace',
    // 'findString',
    //'replaceString',
    'ignoreSpaces',
    'matchCase',
    'isEnabled',
    'sampleHits',
    'sampleGroupHits',
    'hits',
    'groupHits'];

  isRuleSetEmpty = true;
  isRuleExecuting = false;

  private readonly _copilotCtxSvc = inject(CopilotContextService);

  updateDataSource: any;

  previewDataViewModel = new ImportDataViewModel();
  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();
  
  isRulesMaximized = false;

  sortCtrl = new UntypedFormControl('');

  form: FormGroup;

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private fileDownloadService: FileDownloadService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder) {

    super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
    this.transformType = TransformType.rowExtractor;
  }
  selectedIndex: number = 0;
  isPreviewPanelExpanded = false;
  isDescriptionExpanded = false;

  protected override onAnalysisPreviewReceived(data?: any): void {
    this.userData.setResultsTabClicked(true);
    if (data?.triggeredBy === 'button') {
      this.isResultsPanelExpanded = true;
      this.resultsDashboardTabIndex = 2;
      setTimeout(() => this.bindCopilotPreviewIfReady(), 310);
    }
  }

  onResultsDashboardTabChanged(event: any): void {
    if (event.index === 2) {
      // Wait for the tab animation (300ms) before the ViewChild is in the DOM
      setTimeout(() => this.bindCopilotPreviewIfReady(), 310);
    }
  }

  // Audit
  auditSubTabIndex: number = 0;
  auditScorecardStats: { label: string; value: string; width?: string; tooltip?: string }[] = [];

  protected override getAuditRunAll(): boolean {
    return !!this.viewModel?.runAll;
  }

  protected override _triggerAuditRun(): void {
    if (this.getAuditRunAll()) {
      this.showConfirmDialog(
        'Run Audit',
        'Running an Audit with Run All Rows on can take quite some time.',
        (confirmed) => { if (confirmed) this._runAudit(); },
        'Run Audit'
      );
    } else {
      this._runAudit();
    }
  }

  private _runAudit(): void {
    if (!this._copilotSessionId) {
      this.displayError('No Copilot session. Please open the Copilot tab first.', 'Audit');
      return;
    }
    this.auditScorecardStats = [];
    this._auditFilterValuesCache.clear();

    const userId = this.userData.getUserId();
    const config = this.getCopilotConfig();
    const runAll = this.getAuditRunAll();
    const busy   = this.showBusyDialog('Running the Audit');

    this._copilotSvc.runAudit(this._copilotSessionId, userId, config, runAll).subscribe({
      next: (result) => {
        busy.close();
        const _now = new Date();
        const _pad = (n: number) => String(n).padStart(2, '0');
        const _lastRun = `${_now.getFullYear()}-${_pad(_now.getMonth() + 1)}-${_pad(_now.getDate())} ${_pad(_now.getHours())}:${_pad(_now.getMinutes())}`;
        this.auditScorecardStats = [
          { label: 'Last Run', value: _lastRun, width: '175px', tooltip: 'Time the audit completed (browser local time).' },
          ...(result.scorecard ?? []),
        ];
        this.isResultsPanelExpanded   = true;
        this.resultsDashboardTabIndex = 3;
        setTimeout(() => {
          if (this.auditPreviewTable && result.previewData) {
            const pd = new PreviewData();
            pd.columns               = result.previewData.columns as any;
            pd.rows                  = result.previewData.rows;
            pd.totalRows             = result.previewData.totalRows;
            pd.filterInfo            = null;
            pd.cacheFileCreationDtTime = '';
            this.auditPreviewTable.bindData(pd, 'No audit data').then(() => {
              if (this.auditPreviewTable) {
                this.auditPreviewTable.totalRows = result.previewData.totalRows;
                this._applyAuditColumnWidths();
              }
            });
          }
        }, 310);
      },
      error: (err) => {
        busy.close();
        this.displayError(err?.error?.error ?? 'Audit failed.', 'Audit');
      },
    });
  }
  transformerInputPreviewCacheKey = "";
  
  //other parameters
  runAll: ParameterSetting=new ParameterSetting();
  missesNamed: ParameterSetting=new ParameterSetting();
  rowMissesOption: ParameterSetting=new ParameterSetting();
  //advanced settings parameters
  bufferRows: ParameterSetting=new ParameterSetting();
  threads: ParameterSetting=new ParameterSetting();
  searchWildCard: ParameterSetting=new ParameterSetting();
  //multiTargetColumn: ParameterSetting=new ParameterSetting();
  resetRows: ParameterSetting=new ParameterSetting();
  defMaxLength: ParameterSetting=new ParameterSetting();
  defMinLength: ParameterSetting=new ParameterSetting();
  defMaxSearch: ParameterSetting=new ParameterSetting();
  sequenceOption: ParameterSetting=new ParameterSetting();

  @ViewChild(TransformerTopHeaderComponent) topHeaderComponent: TransformerTopHeaderComponent;
  // parametersComponent is now declared on BaseTransformerUIComponent (the Architect,
  // 2026-09-27), promoted so resetTransformer() there can use it for every type.
  options: string[] =[];
  optionsTarget: string[] =[];
  defaultSourceColumn='Source Field';
  defaultTargetColumn='Target Field';
  transformType:TransformType;
  ngOnInit(): void {
    super.ngOnInit();
    this.userData.setInputTabClicked(false);
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.resetInputPrvwViewModel();
    this.transformerInputPreviewCacheKey = "";
    //validation
    this.form = this.fb.group({
      //groupByField: [null, [Validators.required]],
      bufferRows: ['', []],
      threads: ['', []],
      defMinLength: ['', []],
      defMaxLength: ['', []],
      defMaxSearch: ['', []],
      searchWildCard: ['', []]
    });
    this.registerFormGroup(this.form);

    this.totalRulesColumnDisplay();
  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    this.viewModel = new RowExtractorViewModel(
      this.dataDictService,
      this.configService,
      this.dataTransformConfigViewModel,
      this.transformViewModel);
    this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
    this.snapshotPreState();

    this.dataSource = new MatTableDataSource<RowExtractorRuleViewModel>(this.viewModel.rules);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;
    this._refreshHasFindPhrasesRules();

    if (this.previewTable) { this.previewTable.clear(); }
    if (this.outputDataFarmPreviewTable) { this.outputDataFarmPreviewTable.clear(); }

    await this.setTransformerDetails(this.transformType);
    await this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
    await this.downloadInputDataAsync();
    this.viewModel.parameters.targetColumns=this.viewModel.targetColumns;
    this.optionsTarget=[...this.viewModel.targetColumns.map(col => col).sort((a, b) => a.localeCompare(b))];
    this.refreshCopilotConstraints();
    this.viewModel.parameters.sourceColumns = this.viewModel.sourceColumns;
    this._computeSourceOptions();
    await this.setDefaultValues(this.transformType);
    await this.removeInvalidValues();
    this.validateRules();
    this.onrowMissesOptionChange();
  } 

  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: RowExtractorRuleViewModel = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
    this.viewModel.reindexRules();
    this._updateRuleTable();
  }

  private _updateRuleTable(rules: RowExtractorRuleViewModel[] = this.viewModel.rules): void {
    this.dataSource.data = rules;
    this._computeSourceOptions();
    this._refreshHasFindPhrasesRules();
    const n = this.viewModel.rules.length;
    this.minrowcount = Math.min(n, 10);
    this.maxrowcount = n;
  }

  _computeSourceOptions(): void {
    const farmCols = new Set(this.viewModel.sourceColumns.map(col => col.text));
    if (this.viewModel.sequenceOption !== SequenceOption.recursive) {
      this.options = [...farmCols].sort((a, b) => a.localeCompare(b));
      return;
    }
    const extra = new Set<string>();
    for (const rule of this.viewModel.rules) {
      if (rule.run && rule.targetColumn && !farmCols.has(rule.targetColumn)) {
        extra.add(rule.targetColumn);
      }
    }
    this.options = [...farmCols, ...extra].sort((a, b) => a.localeCompare(b));
  }

  private _validateRecursiveSourceFields(): string | null {
    if (this.viewModel.sequenceOption !== SequenceOption.recursive) return null;
    const farmCols = new Set(this.viewModel.sourceColumns.map(col => col.text));
    const badRules: string[] = [];
    for (const rule of this.viewModel.rules) {
      if (!rule.run) continue;
      if (farmCols.has(rule.sourceColumn)) continue;
      const providedUpstream = this.viewModel.rules.some(
        r => r.run && r.index < rule.index && r.targetColumn === rule.sourceColumn
      );
      if (!providedUpstream) {
        badRules.push(TransformRuleViewModel.label(rule));   // index is already the table's number
      }
    }
    if (badRules.length === 0) return null;
    // The standard several-rules layout: the problem, then one "Rule N: Name" per line.
    return ['These rules read a Source Field that is not in the input and that no earlier rule creates:',
            ...badRules].join('\n');
  }

  onRunChanged(event: MatSlideToggleChange): void {
    this.viewModel.rules.forEach( r => r.run = event.checked);
  }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }

  compareDataFarm(o1: DataFarmViewModel, o2: DataFarmViewModel): boolean {
    return o1.name === o2.name && o1.id === o2.id;
  }

  removeSortInfo(sortInfo: SortInfo): void {
    const index = this.viewModel.sortInfo?.indexOf(sortInfo);

    if (index >= 0) {
      this.viewModel.sortInfo?.splice(index, 1);
    }
  }
  
  showSortBuilder(): void {
    const dialog = this.matDialog.open(SortBuilderComponent, {
      data: {
        fields: this.viewModel.sourceColumns.map(c => c.text),
        sortItems: [...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const items = result.sortItems;
      this.viewModel.sortInfo = items;
      this.sortCtrl.setValue(null);
    });
  }

  onDeleteRule(rule: RowExtractorRuleViewModel): void {
    this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
      if (confirmed) {
        const index = this.viewModel.rules.indexOf(rule);
        this.viewModel.rules.splice(index, 1);
        this.viewModel.reindexRules();

        this._updateRuleTable();
        this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      }
    });
  }

  onDuplicateRule(sourceRule: RowExtractorRuleViewModel): void {
    
    const vm = new RowExtractorRuleViewModel(new RowExtractorTransformRule());
    Object.assign(vm, sourceRule);
    
    this.viewModel.rules.splice(sourceRule.index, 0, vm);
    this.viewModel.reindexRules();
    this._updateRuleTable();
    if(vm.index==this.maxrowcount){this.isScrollBottom=true; }else{this.isScrollBottom=false;}
  }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
  addNewRule(): void {
    var isValidDefaultParam=true;
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==this.transformType);
    var params=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid).parameters.filter(n=>n.isruledefault==true);
    params.forEach(field => {
      if(field.jsonobject=="defSourceField"){
        if(!this.viewModel.parameters.sourceColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="defTargetField"){
        if(!this.viewModel.parameters.targetColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="userIdField"){
        if(!this.viewModel.parameters.userColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="timestampField"){
        if(!this.viewModel.parameters.timeColumn){
          isValidDefaultParam=false;
        }
      }
    });

    if (!isValidDefaultParam) {
      this.displayError("Cannot add Rule unless Default field(s) are entered.","Please fix the validation error.");
      return;
    }
    const id = this.viewModel.rules.length;
    const rule = new RowExtractorTransformRule();
    rule.ruleId = id;
    rule.index = id;
    rule.sourceField = this.viewModel.parameters.sourceColumn;
    rule.targetField = this.viewModel.parameters.targetColumn;
    rule.startRule=ExtractorStartRuleType.startsWith;
    rule.endRule=ExtractorEndRuleType.endsAtEnd;
    rule.maxSearch=this.viewModel.defMaxSearch;
    rule.minLength=this.viewModel.defMinLength;
    rule.maxLength=this.viewModel.defMaxLength;
    rule.ignoreSpaces=false;
    rule.matchCase=true;
    rule.run=true;

    const vm = new RowExtractorRuleViewModel(rule);

    this.viewModel.rules.push(vm);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;
    this._updateRuleTable();
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
    try {
      return this.getClassForRowBase(sender, row, colInfo, colInfos);
    } catch (err) {
      return null;
    }
  }

  async saveConfig(): Promise<void> {
    if (!this.validate()) {
      return;
    }
    if(!await this.validateRulesRunSave()){
      this.displayError("Illegal Boolean data type conversion, please correct before proceeding:\n" + this.invalidTypeRules.join("\n"),"Validation Error");
      return;
    }
    const recursiveWarning = this._validateRecursiveSourceFields();
    if (recursiveWarning) {
      this.displayWarning(recursiveWarning, 'Recursive Source Field Warning');
      return;
    }
    if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
      this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
    } else {
      this.showSaveConfigDialog(async (configName: string) => {
        this.saveConfigImpl(configName);
      });
    }
    
  }

  async saveConfigImpl(configName: string, isUserInitiated: boolean = true): Promise<void> {
      var currenttransformer_sampleStart = this.viewModel.parameters.sampleStart ;
      var currenttransformer_sampleEnd = this.viewModel.parameters.sampleEnd  ;
    
        if (currenttransformer_sampleStart > currenttransformer_sampleEnd) {
            this.displayWarning(
              'Sample Start was greater than to Sample End, so it was auto-reset to 1.',
              'Warning',
              undefined,
              () => {
                this.viewModel.parameters.sampleStart = 1;
              }
            );
            return;
          }
          if(currenttransformer_sampleStart > this.totalInputRows || currenttransformer_sampleEnd > this.totalInputRows )
        {
    
          this.displayWarning(
            'Sample Range exceeded the Input Farm size and was auto-corrected to the maximum limit.',
            'Warning',
            undefined,  // no exception to pass
            () => {
           
              if (currenttransformer_sampleStart > this.totalInputRows) {
              this.viewModel.parameters.sampleStart = 1;
              }
              if (currenttransformer_sampleEnd > this.totalInputRows) {
                this.viewModel.parameters.sampleEnd = this.totalInputRows;
              }
            }
          );
          return;
        }
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
            ingestConfig.guid, 
            ingestConfig.masterColumnMapGuid)
      );

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      const transform = this.viewModel.transformViewModel.transform;
      transform.transformConfig = this.viewModel.toTransformConfig();

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }      

      config.transforms.push(transform);
      config = await this.configService.upsertConfig(config);
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      const selectedNode = this.userData.getSelectedNodeDetails();
      //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       //this.cacheStatus = 'Not Cached'; // compiled cache key differs from interpreted run; honest until next Node run confirms it
       this.getCacheStatus();
       this.snapshotPreState();

      if (isUserInitiated) {
        const mixedFindPhrasesWarning = this._mixedFindPhrasesWarningIfAny();
        // The Architect, 2026-10-03: the mixed-Find-Phrases advisory only reflects a real
        // performance cost at scale (confirmed live: ~2x penalty on a 2M-row farm, no
        // measurable difference on a small one) -- see _mixedFindPhrasesWarningIfAny()'s own
        // comment for the underlying cause. Below 100,000 input rows it stays folded into
        // the routine blue "Successfully saved" snackbar, same as before. At or above that,
        // it's promoted to the standard orange warning dialog instead, since a snackbar
        // auto-dismisses in 5s and is too easy to miss for something worth acting on.
        const useOrangeWarning = !!mixedFindPhrasesWarning && this.totalInputRows > 100000;
        const savedMessage = `Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`;
        this.snackBar.open(
          (mixedFindPhrasesWarning && !useOrangeWarning) ? `${savedMessage}. ${mixedFindPhrasesWarning}` : savedMessage,
          'Dismiss',
          { duration: 5000 }
        );
        if (useOrangeWarning) {
          this.displayWarning(mixedFindPhrasesWarning!, 'Performance Warning');
        }

        // Notify the Copilot panel that the analyst saved — triggers survey + work-complete flush.
        // Rule counts exclude debug rules (named "(debug)" or prefixed "debug:") and disabled rules.
        const savedRules: any[] = this.viewModel.toTransformConfig()?.rules ?? [];
        const nDebug    = savedRules.filter(r => _isDebugRule(r.ruleName)).length;
        const nDisabled = savedRules.filter(r => !r.run && !_isDebugRule(r.ruleName)).length;
        const nActive   = savedRules.filter(r =>  r.run && !_isDebugRule(r.ruleName)).length;
        this._copilotCtxSvc.emitTransformerSaved({
          nRulesInFinalConfig:   nActive,
          nDebugRulesInConfig:   nDebug,
          nDisabledRulesInConfig: nDisabled,
        });
      }

      busyIndicator.close();

    } catch (err) {
      busyIndicator.close();
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    }
  }

  onSetDefaultRule(defaultfield:string){
    if(defaultfield=="sourceColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.sourceColumn=this.viewModel.parameters.sourceColumn;
      })
    }
    else if(defaultfield=="targetColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.targetColumn=this.viewModel.parameters.targetColumn;
      })
    }
    this.validateRules();
  }
  totalRulesColumnDisplay(){
    //blank values
    this.viewModel.rules.forEach(rule=>{
      rule.hits=null;
    })
    if(this.viewModel.runAll){
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'sourceField',
        'targetField',
        'startRule',
        'startString',
        'startIndex',
        'endRule',
        'endString',
        'endIndex',
        'maxSearch',
        'minLength',
        'maxLength',
        'findReplace',
        'matchAll',
        // 'findString',
        //'replaceString',
        'ignoreSpaces',
        'matchCase',
        'isEnabled',
        'sampleHits',
        'sampleGroupHits',
        'hits',
        'groupHits'];
      }else{
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'sourceField',
        'targetField',
        'startRule',
        'startString',
        'startIndex',
        'endRule',
        'endString',
        'endIndex',
        'maxSearch',
        'minLength',
        'maxLength',
        'findReplace',
        'matchAll',
        // 'findString',
        //'replaceString',
        'ignoreSpaces',
        'matchCase',
        'isEnabled',
        'sampleHits',
        'sampleGroupHits'];
    }
    this.cdRef.detectChanges();
  }
  onToggleRulesColumnDisplay(){
    this.totalRulesColumnDisplay();
  }
  onToggleResetRows(event: any){
    this.viewModel.resetRows=event.checked;
  }
  onParameterFormStatusChange(status: boolean) {
    this.isParameterFormValid = status;
  }

  onFindReplaceCellClicked(rule: RowExtractorRuleViewModel): void {
    let title: string=`Chooser (Find & Replace): Rule ${rule.index}${rule.ruleName ? ' - ' + rule.ruleName : ''}`;
    let labelFind: string="Find";
    let labelReplace: string="Replace";
    let placeholderFind: string="Enter find";
    let placeholderReplace: string="Enter replace";
    let fieldType: string="edit";
    let isDuplicateRemoved: boolean=false;
    let canAddNewAutocomplete: boolean=false;
    let optionsFind: OptionItemDataType[]=[];
    let optionsReplace: OptionItemDataType[]=[];
    let validateboth: boolean=false;
    let isDataTypeCheck: boolean=false;
    let dialogWidth: string='650px';
    this.showFindReplaceEditorDialogOption(title,labelFind,labelReplace,placeholderFind,placeholderReplace,fieldType,isDuplicateRemoved,canAddNewAutocomplete,optionsFind,optionsReplace,validateboth,isDataTypeCheck,dialogWidth,
      [...rule.findReplaceList],
      async (items: ColoredTextFindReplaceItem[],eventname:string) => {
        if(eventname=='save'){
        rule.findReplaceList = items;
        }
      });
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
   this.userData.setResultsTabClicked(false);
   if(selectedTabLabel.match("Output") && selectedTabIndex == 1) {
    this.userData.setOutputTabClicked(true)
    this.setOutputPreviewTabSlctnStatus();
   } else {
      this.userData.setOutputTabClicked(false);
      this.setInputPreviewFilterViewModel();
   }
  }

  setRowExtractorResultsTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    
    this.userData.setOutputTabClicked(false);
    this.userData.setResultsTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    this.isResultsPanelExpanded = true;
    this.isPreviewPanelExpanded = false;
  }

  setRowExtractorPreviewTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.isResultsPanelExpanded = false;
    this.isPreviewPanelExpanded = true;
    if(this.selectedIndex == 0) {
      this.setInputPreviewFilterViewModel();
    }
    if(this.selectedIndex == 1) {
      this.setOutputPreviewTabSlctnStatus();
    }
  }

  setOutputPreviewTabSlctnStatus(): void {
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }

  setInputPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.setTransformerInputPrvwCacheKey();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
  }
  
  setTransformerInputPrvwCacheKey() {
    if(this.transformerInputPreviewCacheKey.length > 0 && this.inputPrvwFilterViewModel.farmId.length > 0) {
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = this.transformerInputPreviewCacheKey;
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    }
  }
  resetInputPrvwViewModel() {
    this.inputPrvwFilterViewModel.farmId = "";
    this.inputPrvwFilterViewModel.collookupFarmId = "";
    this.inputPrvwFilterViewModel.nodeType = "";
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
  }

  resetTransformerInputPrvwModelData() {
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    this.inputPrvwFilterViewModel.previewType = "";
  }

  get isValidateParameters(): boolean {
    return !this.isParameterFormValid;
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }
 
  
  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      //other parameters
      this.runAll=params.find(x=>x.jsonobject=='runAll' && x.iscommonparam==false);
      this.missesNamed=params.find(x=>x.jsonobject=='missesNamed' && x.iscommonparam==false);
      this.rowMissesOption=params.find(x=>x.jsonobject=='rowMissesOption' && x.iscommonparam==false);
      //advanced settings parameters
      this.bufferRows=params.find(x=>x.jsonobject=='bufferRows');
      this.threads=params.find(x=>x.jsonobject=='threads');
      this.searchWildCard=params.find(x=>x.jsonobject=='searchWildCard');
      this.resetRows=params.find(x=>x.jsonobject=='resetRows');
      this.defMaxLength=params.find(x=>x.jsonobject=='defMaxLength');
      this.defMinLength=params.find(x=>x.jsonobject=='defMinLength');
      this.defMaxSearch=params.find(x=>x.jsonobject=='defMaxSearch');
      this.sequenceOption=params.find(x=>x.jsonobject=='sequenceOption');
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
        if(this.resetRows.default!=""){
          this.viewModel.resetRows=this.stringToBoolean(this.resetRows.default);
        }
        //other parameters
        if(this.runAll.default!=""){
          this.viewModel.runAll=this.stringToBoolean(this.runAll.default);
        }
        if(this.missesNamed.default!=""){
          this.viewModel.missesNamed=this.missesNamed.default;
        }
        if(this.rowMissesOption.default!=""){
          this.viewModel.rowMissesOption=Number(this.rowMissesOption.default);
        }
        //advanced settings parameters
        if(this.bufferRows.default!=""){
          this.viewModel.bufferRows=Number(this.bufferRows.default);
        }
        if(this.threads.default!=""){
          this.viewModel.threads=Number(this.threads.default);
        }
        if(this.searchWildCard.default!=""){
          this.viewModel.searchWildCard=this.searchWildCard.default;
        }
        if(this.defMaxLength.default!=""){
          this.viewModel.defMaxLength=Number(this.defMaxLength.default);
        }
        if(this.defMinLength.default!=""){
          this.viewModel.defMinLength=Number(this.defMinLength.default);
        }
        if(this.defMaxSearch.default!=""){
          this.viewModel.defMaxSearch=Number(this.defMaxSearch.default);
        }
        if(this.sequenceOption.default!=""){
          this.viewModel.sequenceOption=Number(this.sequenceOption.default);
        }
      }
    }else{
      //advanced settings parameters
      this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      this.threads.label="Threads (0 > Auto)";this.threads.jsonobject="threads";this.threads.min=0;this.threads.max=64;
      this.defMinLength.label="Default Min Length";this.defMinLength.jsonobject="defMinLength";this.defMinLength.min=0;this.defMinLength.max=10000000;
      this.defMaxLength.label="Default Max Length";this.defMaxLength.jsonobject="defMaxLength";this.defMaxLength.min=0;this.defMaxLength.max=10000000;
      this.defMaxSearch.label="Default Max Search";this.defMaxSearch.jsonobject="defMaxSearch";this.defMaxSearch.min=0;this.defMaxSearch.max=10000000;
      this.searchWildCard.label="Wild Card";this.searchWildCard.jsonobject="searchWildCard";
      this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }

  async removeInvalidValues(): Promise<void> {}

  async loadImportTransformer(transform: any): Promise<void>{
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
        this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
        return;
      }else if(this.transformType!=transform.transformType){
        this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
        return;
      }
      var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
      ctranformconfig.transform.transformConfig=transform;
      var newmodel =new RowExtractorViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
      // force new object reference for UI refresh
      this.viewModel.rules=[];
      this.viewModel.rules=[...newmodel.rules];
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      //update Parameters
      this.viewModel.parameters.sourceColumn=newmodel.parameters.sourceColumn;
      this.viewModel.parameters.targetColumn=newmodel.parameters.targetColumn;
      this.viewModel.parameters.sortInfo=newmodel.parameters.sortInfo;
      this.viewModel.parameters.includeInResults=newmodel.parameters.includeInResults;
      this.viewModel.parameters.sampleStart =newmodel.parameters.sampleStart;
      this.viewModel.parameters.sampleEnd =newmodel.parameters.sampleEnd;
      //other parameters
      this.viewModel.runAll=newmodel.runAll;
      this.viewModel.missesNamed =newmodel.missesNamed;
      this.viewModel.rowMissesOption =newmodel.rowMissesOption;
      this.viewModel.sequenceOption =newmodel.sequenceOption;
      this._updateRuleTable();
      //advanced settings parameters
      this.viewModel.bufferRows = newmodel.bufferRows;
      this.viewModel.threads = newmodel.threads;
      this.viewModel.searchWildCard = newmodel.searchWildCard;
      this.viewModel.resetRows = newmodel.resetRows;
      this.viewModel.defMaxLength = newmodel.defMaxLength;
      this.viewModel.defMinLength = newmodel.defMinLength;
      this.viewModel.defMaxSearch = newmodel.defMaxSearch;
    }catch (err) {
      this.displayError(`Failed to save import transformer`, 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }

  /** resetTransformer() itself is inherited from BaseTransformerUIComponent (the
   *  Architect, 2026-09-27 — generalized to every transform type except the
   *  auto-configured Farm Joiner/Farm Converter). This hook covers the two pieces of
   *  that reset which are genuinely Row-Extractor-specific and don't generalize:
   *  rule-datatype validation and the row-misses advanced-setting side effect. */
  protected override async onAfterResetTransformer(): Promise<void> {
    this.validateRules();
    this.onrowMissesOptionChange();
  }

  isValidRuleType:boolean=true;
  /** Rules that would fail a Run on an illegal Boolean conversion -- only rules that are on
   * (a rule that is off is not run, so it is not checked). */
  invalidTypeRules: string[] = [];
  async validateRulesRunSave(): Promise<boolean>{
    this.invalidTypeRules = [];
    for (const rule of TransformRuleViewModel.enabledRules(this.viewModel.rules)) {
      this.isValidRuleType=true;
      await this.validateDataType(rule);
      if (!this.isValidRuleType) {
        this.invalidTypeRules.push(TransformRuleViewModel.label(rule));
      }
    }
    this.isValidRuleType = this.invalidTypeRules.length === 0;
    return this.isValidRuleType;
  }
  async validateRules(): Promise<void>{
    for (const rule of this.viewModel.rules) {
      await this.validateDataType(rule);
    }
  }
  async validateDataType(rule:RowExtractorRuleViewModel): Promise<void>{
    const optionitemSource=await this.getPreviewTableOptionItemDataTypePD(this.inputDataFarmPreviewTable);
    const optionitemTarget=await this.getDataDictOptionItemDataTypePD(this.userData.getSelectedNodeDetails().farmtypeid);
    const sourceFieldDatatype=optionitemSource.find(item=>item.text==rule.sourceColumn)?.dataType;
    const targetFieldtargetField=optionitemTarget.find(item=>item.text==rule.targetColumn)?.dataType;
    const sourceFieldDatatypeCon=this.getDataType(sourceFieldDatatype);
    const targetFieldtargetFieldCon=this.getDataType(targetFieldtargetField);
    
    if(sourceFieldDatatypeCon!=targetFieldtargetFieldCon){
      rule.tooltipMessage ="This rule will attempt to convert from "+sourceFieldDatatype+" to "+targetFieldtargetField+".  if this doesn’t succeed, the rule will not be processed.";
      rule.tooltipType="blue"
    }else {
      rule.tooltipMessage = '';
    }

    const inValidTypes = ["int", "float", "datetime", "timedelta"];
    if ((sourceFieldDatatypeCon === "boolean" && inValidTypes.includes(targetFieldtargetFieldCon))){
      rule.tooltipMessage = `Attempting to convert boolean to `+targetFieldtargetFieldCon+` data types will fail.`;
      rule.tooltipType="red"
      this.isValidRuleType=false;
    }else if ((targetFieldtargetFieldCon === "boolean" && inValidTypes.includes(sourceFieldDatatypeCon))){
      rule.tooltipMessage = `Attempting to convert boolean from `+sourceFieldDatatypeCon+` data types will fail.`;
      rule.tooltipType="red"
      this.isValidRuleType=false;
    }
  }
  getTooltipStyle(rule:RowExtractorRuleViewModel): { [klass: string]: string } {
    if (!rule.tooltipMessage) return {};

    switch (rule.tooltipType) {
      case 'blue':
        return { 'background-color': '#085296' };
      case 'red':
        return { 'background-color': '#940000' };
      default:
        return {};
    }
  }
  onEndRuleTypeChange(rule: RowExtractorRuleViewModel, newType: ExtractorEndRuleType): void {
    if (newType === ExtractorEndRuleType.findPhrases &&
        rule.startRuleType === ExtractorStartRuleType.lengthBetween) {
      rule.startRuleType = ExtractorStartRuleType.beginning;
    }
    this._refreshHasFindPhrasesRules();
  }

  async onRunTransformValidateRules() {
    if(!await this.validateRulesRunSave()){
      this.displayError("Illegal Boolean data type conversion, please correct before proceeding:\n" + this.invalidTypeRules.join("\n"),"Validation Error");
      return;
    }
    const recursiveWarning = this._validateRecursiveSourceFields();
    if (recursiveWarning) {
      this.displayWarning(recursiveWarning, 'Recursive Source Field Warning');
      return;
    }
    await this.onRunTransform();
  }
  // Assuming you already have viewModel.rowMissesOption bound properly
    isMissNameDisabled: boolean = true;
  
    onrowMissesOptionChange(): void {
      if(this.viewModel.rowMissesOption==RowMissesOptionExtractor.named){
        this.isMissNameDisabled = false;
      }else{
        this.isMissNameDisabled = true;
      }
    }

  // ── Copilot integration ──────────────────────────────────────────────

  protected override getCopilotTransformType(): number {
    return 0; // TransformType.rowExtractor
  }

  protected override getCopilotColumnNames(): string[] {
    return this.viewModel?.sourceColumns?.map(c => c.text) ?? [];
  }

  /** Distinct fields referenced by this config's rules, Default Source Field first — Smart Sample dropdown. */
  get extractorAvailableSourceFields(): string[] {
    const defaultField = this.viewModel?.parameters?.sourceColumn;
    const fromRules = collectDistinctSourceFields(this.viewModel?.rules, r => r.sourceColumn);
    if (!defaultField) return fromRules;
    return [defaultField, ...fromRules.filter(f => f !== defaultField)];
  }

  protected override getCopilotConstraints(): any {
    return {
      sourceColumns: this.options ?? [],
      targetColumns: this.optionsTarget ?? [],
      startRuleTypes: {
        uiLabel: 'Start Rule',
        options: this.StartRuleTypes.map(r => ({ value: r, label: StartRuleTypeUtil.toString(r) })),
      },
      endRuleTypes: {
        uiLabel: 'End Rule',
        options: this.EndRuleTypes.map(r => ({ value: r, label: EndRuleTypeUtil.toString(r) })),
      },
      rowMissesOptions: {
        uiLabel: 'Missed Rows',
        jsonKey:  'rowMissesOption',
        options: this.RowMissesOptionExtractors.map(r => ({ value: r, label: RowMissesOptionExtractorUtil.toString(r) })),
      },
      sequenceOptions: {
        uiLabel: 'Sequence',
        jsonKey:  'sequenceOption',
        options: this.SequenceOptions.map(r => ({ value: r, label: SequenceOptionUtil.toString(r) })),
      },
      missesNamed: {
        uiLabel:  'Missed Rows Name',
        jsonKey:  'missesNamed',
        freeText: true,
      },
      searchWildCard: {
        uiLabel:  'Wildcard Character',
        jsonKey:  'searchWildCard',
        freeText: true,
      },
      // Added 2026-09-08 alongside the Find Phrases Consolidation redesign — until
      // now Copilot had no way to set this field at all (apply_setting resolves
      // settable fields entirely from this method; no Python change is needed to
      // add a new one). Reuses the same ConsolidationLevels/ConsolidationLevelUtil
      // the Advanced Settings dropdown itself uses, so Copilot's options always
      // match what's actually selectable in the UI.
      consolidationOptions: {
        uiLabel: 'Consolidation',
        jsonKey: 'consolidation',
        options: this.ConsolidationLevels.map(l => ({ value: l, label: ConsolidationLevelUtil.toString(l) })),
      },
      defaults: {
        startRule: ExtractorStartRuleType.startsWith,
        endRule:   ExtractorEndRuleType.endsAtEnd,
        ignoreSpaces: false,
        matchCase:    true,
      },
    };
  }

  protected override getCopilotConfig(): any {
    return this.viewModel?.toTransformConfig() ?? {};
  }

  protected override getCopilotRunStats(): any {
    if (!this.viewModel) return {};
    return {
      globalStat: {
        rowHits:   this.viewModel.hitCount  ?? 0,
        rowMisses: this.viewModel.missCount ?? 0,
        hitRate:   this.viewModel.hitRatio  ?? 0,
      },
      ruleStats: (this.viewModel.rules ?? []).map((r: any, i: number) => ({
        ruleIndex:        i + 1,
        rowHits:          r.hits          ?? r.sampleHits          ?? 0,
        groupHits:        r.groupHits     ?? null,   // total variants (runAll=true)
        sampleGroupHits:  r.sampleGroupHits ?? null, // sample variants
      })),
      totalRows: (this.viewModel.hitCount ?? 0) + (this.viewModel.missCount ?? 0),
    };
  }

  protected override async _runForCopilotAnalysis(): Promise<void> {
    const saved = this.viewModel.runAll;
    this.viewModel.runAll = true;
    this.totalRulesColumnDisplay();
    try {
      await super._runForCopilotAnalysis();
    } finally {
      this.viewModel.runAll = saved;
      this.totalRulesColumnDisplay();
    }
  }

  protected override applySortedRules(rules: any[]): void {
    if (!rules?.length) return;
    const ctranformconfig = this.dataTransformConfigViewModel.transforms
      .find(x => x.guid === this.userData.getSelectedTransform().guid);
    if (!ctranformconfig) return;

    // Re-sort the existing view model rules to match the new order, preserving
    // hit stats already computed from the last run. Match by startPattern
    // (view model) == startString (config) — unique per rule.
    // Config indices are 0-based; view model indices are 1-based.
    const positionByStartString = new Map<string, number>();
    rules.forEach((r, i) => positionByStartString.set((r.startString ?? '').toLowerCase(), i));

    const sorted = [...this.viewModel.rules].sort((a, b) => {
      const ap = positionByStartString.get((a.startPattern ?? '').toLowerCase()) ?? 9999;
      const bp = positionByStartString.get((b.startPattern ?? '').toLowerCase()) ?? 9999;
      return ap - bp;
    });
    sorted.forEach((r, i) => { r.index = i + 1; });

    this.viewModel.rules = sorted;
    this._updateRuleTable(sorted);
  }

  protected override async applyCopilotConfig(config: any, mode: 'replace' | 'merge' | 'preview', skipRun: boolean = false): Promise<void> {
    if (config?.analystDescriptionAppend) {
      const existing = this.viewModel.transform.analystDescription || '';
      const divider = existing ? '<hr>' : '';
      // Newest-first: each Copilot-written entry (Save survey, Analysis survey, mid-session
      // Requirements summary) is prepended above whatever's already there, per the
      // Architect's direction (2026-09-10) that the Description field should read
      // newest-at-top rather than accumulate downward.
      this.viewModel.transform.analystDescription = config.analystDescriptionAppend + divider + existing;
      this.isDescriptionExpanded = true;

      // This arrives after the analyst's own Save Transformer click already persisted the
      // config — without this, the summary only exists in memory and is lost on navigation
      // (canDeactivate wouldn't even warn, since it fired after this snapshot updated
      // preAnalystDescription). Silently re-persist just this addition; isUserInitiated=false
      // skips the toast and the Copilot-saved notification so the survey doesn't re-trigger.
      const configName = this.dataTransformConfigViewModel.dataTransformerConfig?.name;
      if (configName) {
        this.saveConfigImpl(configName, false);
      }
    }

    if (!config?.rules) return;

    const ctranformconfig = this.dataTransformConfigViewModel.transforms
      .find(x => x.guid === this.userData.getSelectedTransform().guid);
    if (!ctranformconfig) return;

    // Flask owns the merge: it applies improvements to existing rules and appends
    // gap rules, returning the complete final rule list.  Use config.rules directly
    // for both modes so DTR runs on exactly the config Copilot analysed.
    const targetRules = config.rules;

    // Temporarily set the config so RowExtractorViewModel can parse rules into
    // typed view-model objects, then restore immediately.
    // Copilot populates and can run the transformer — it does NOT save it.
    const savedConfig = ctranformconfig.transform.transformConfig;

    // Collect every jsonKey declared in constraints — these are all the non-rule
    // settings Copilot can change. New settings added to getCopilotConstraints()
    // are automatically handled here without any code change.
    const constraintKeys: string[] = Object.values(this.getCopilotConstraints() as Record<string, any>)
      .filter((g): g is { jsonKey: string } => g != null && typeof g === 'object' && typeof g.jsonKey === 'string')
      .map(g => g.jsonKey);

    try {
      const tempConfig: any = { ...savedConfig, rules: targetRules };
      for (const key of constraintKeys) {
        if (config[key] !== undefined) tempConfig[key] = config[key];
      }

      ctranformconfig.transform.transformConfig = tempConfig;
      const newmodel = new RowExtractorViewModel(
        this.dataDictService, this.configService, this.dataTransformConfigViewModel, ctranformconfig
      );

      this.viewModel.rules  = [...newmodel.rules];
      this.isRuleSetEmpty   = this.viewModel.rules.length === 0;

      for (const key of constraintKeys) {
        if (config[key] !== undefined) (this.viewModel as any)[key] = (newmodel as any)[key];
      }
      this._updateRuleTable();
      if (this.viewModel.rules.length > 11) this.isRulesMaximized = true;
      // Side effect: rowMissesOption controls whether the Named text field is shown
      if (config.rowMissesOption !== undefined) this.onrowMissesOptionChange();

      if (config.sampleStart !== undefined) this.viewModel.parameters.sampleStart = config.sampleStart + 1;
      if (config.sampleEnd   !== undefined) this.viewModel.parameters.sampleEnd   = config.sampleEnd   + 1;
      if (config.sortInfo    !== undefined) {
        this.viewModel.sortInfo            = config.sortInfo;
        this.viewModel.parameters.sortInfo = config.sortInfo;
      }
      // Copilot keeps these in sync with its currently-resolved source/target,
      // overwriting any prior value when valid (see default_fields.sync_default_fields).
      if (config.defSourceField !== undefined) this.viewModel.parameters.sourceColumn = config.defSourceField;
      if (config.defTargetField !== undefined) this.viewModel.parameters.targetColumn = config.defTargetField;
    } finally {
      // Restore the persisted config — the Analyst owns Save.
      // Also guarded structurally by _isCopilotRun in runCurrentTransform.
      ctranformconfig.transform.transformConfig = savedConfig;
    }

    // Push the updated view-model config (with Copilot's rules/settings) back into
    // the copilot context so refreshContext always carries the live config to the backend.
    this._copilotCtxSvc.update({ currentConfig: this.getCopilotConfig() });
    this.totalRulesColumnDisplay();

    if (targetRules.length === 0) {
      // Nothing to extract — clear the Results Dashboard and Output Data Preview
      // directly instead of invoking the engine on an empty rule list. There is
      // nothing for it to run, and trying only costs time for no benefit.
      this.copilotStats       = [];
      this.copilotLog         = [];
      this.copilotContamStats = [];
      const rvm = this.viewModel as any;
      rvm.hitCount        = null;
      rvm.hitRatio        = null;
      rvm.missCount       = null;
      rvm.variantCount    = null;
      rvm.hitRatioDisplay = '0.00%';
      rvm.rows            = 0;
      this.previewTable?.clear();
      this.outputDataFarmPreviewTable?.clear();
      this.copilotPreviewTable?.clear();
      return;
    }

    if (skipRun) {
      // Still-staging batch rule (BPM defer_run) — the Rules Table above was already
      // updated with this rule; no live run has happened and none should be launched here.
      // A real run follows once the batch is validated (see extractor_agent.py's
      // run_transformer push for BPM), or at the final checkpoint's own safety-net run.
      return;
    }

    // Raise the flag immediately so the navigation guard sees DTR as in-flight even
    // before the deferred setTimeout fires (the button is enabled by then).
    this._dtrRunning = true;
    this.viewModel.runAll = config.runAll === true;

    if (this._copilotDtrInFlight) {
      // A Copilot-triggered DTR run is already in flight. Queueing a concurrent run
      // would write to the same feather output file simultaneously and corrupt it.
      // Store the latest pending args — onCopilotDtrComplete will re-launch after the
      // current run finishes. The view model is already updated above, so the re-run
      // will use the latest config automatically.
      this._copilotDtrPending = { mode, savedConfig, ctranformconfig };
      return;
    }
    this._launchCopilotDtr(mode, savedConfig, ctranformconfig);
  }

  // ── serialised Copilot-run helpers ──────────────────────────────────────

  private _copilotDtrInFlight = false;
  private _copilotDtrPending: {
    mode: 'replace' | 'merge' | 'preview';
    savedConfig: any;
    ctranformconfig: any;
  } | null = null;

  private _launchCopilotDtr(
    mode: 'replace' | 'merge' | 'preview',
    savedConfig: any,
    ctranformconfig: any,
  ): void {
    this._copilotDtrInFlight = true;
    this._copilotDtrPending  = null;
    this._dtrRunning         = true;
    setTimeout(async () => {
      this._isCopilotRun = true;
      this._isCopilotPreviewRun = (mode === 'preview');
      try {
        await this.onRunTransform();
      } finally {
        this._isCopilotRun = false;
        this._isCopilotPreviewRun = false;
        ctranformconfig.transform.transformConfig = savedConfig;
        this._skipNextSortedRules = true;
      }
    }, 0);
  }

  protected override onCopilotDtrComplete(): void {
    this._copilotDtrInFlight = false;
    if (this._copilotDtrPending) {
      // A newer config update arrived while this run was in flight.
      // Re-run now — the view model was already updated by applyCopilotConfig.
      // Do not emit _dtrRunComplete$ yet; wait for the re-run to finish.
      const pending = this._copilotDtrPending;
      this._copilotDtrPending = null;
      this._launchCopilotDtr(pending.mode, pending.savedConfig, pending.ctranformconfig);
    } else {
      super.onCopilotDtrComplete(); // emits _dtrRunComplete$ → releases deferred navigation
    }
  }
}





/** Mirrors the Python is_debug_rule() classifier in classifiers.py. */
function _isDebugRule(ruleName: string): boolean {
  const name = (ruleName ?? '').toLowerCase().trim();
  return name.includes('(debug)') || name.startsWith('debug:');
}
